import { gql } from '@src/__generated__';

export const GET_NARRATIVE_VERSIONS = gql(`
  query GetNarrativeVersions($tripProfileId: ID!) {
    getNarrativeVersions(tripProfileId: $tripProfileId) {
      id
      tripProfileId
      version
      status
      promptVersionId
      inputParams
      docS3Key
      modelName
      durationMs
      inputTokens
      outputTokens
      totalTokens
      errorMessage
      createdAt
      updatedAt
    }
  }
`);

export const GET_NARRATIVE_DOWNLOAD_URL = gql(`
  query GetNarrativeDownloadUrl($narrativeVersionId: ID!) {
    getNarrativeDownloadUrl(narrativeVersionId: $narrativeVersionId)
  }
`);
